import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { SiteShell } from "./Landing";
import api, { apiError } from "../lib/api";

function LegalPage({ slug, testid }) {
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setErr("Siden kunne ikke hentes. Prøv igen."));
  }, [slug]);
  return (
    <SiteShell>
      <div className="legal" data-testid={testid}>
        {err && <p className="muted" data-testid="legal-error">{err}</p>}
        {doc && (
          <>
            <header className="legal-hero">
              <span className="legal-eyebrow">{doc.eyebrow}</span>
              <h1 data-testid="legal-title">{doc.title}</h1>
              <p>{doc.intro}</p>
              <div className="legal-meta">
                <span data-testid="legal-updated">Senest opdateret: {doc.updated}</span>
                <span>Adtimera ApS · CVR 40551867</span>
                {doc.meta?.filter((m) => !m.startsWith("Adtimera")).map((m) => <span key={m}>{m}</span>)}
                <a href={`mailto:${doc.contact}`}>{doc.contact}</a>
              </div>
            </header>
            <div className="legal-grid">
              <nav className="legal-toc" aria-label="Indhold">
                <b>Indhold</b>
                {doc.sections.map((s) => (
                  <a key={s.id} href={`#${s.id}`}>{s.title}</a>
                ))}
              </nav>
              <div className="legal-doc">
                {doc.sections.map((s, i) => (
                  <section id={s.id} key={s.id} data-testid={`legal-section-${s.id}`}>
                    <h2><span className="n">{i + 1}</span>{s.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: s.html }} />
                  </section>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </SiteShell>
  );
}

export const PrivacyPage = () => <LegalPage slug="privatliv" testid="privacy-page" />;
export const TermsPage = () => <LegalPage slug="vilkaar" testid="terms-page" />;
export const DpaPage = () => <LegalPage slug="databehandleraftale" testid="dpa-page" />;
export const DeletionPage = () => <LegalPage slug="sletning-af-data" testid="deletion-page" />;

const KIND = { deletion: "Sletning af data fra Facebook", deauthorize: "Appen fjernet på Facebook" };

export function DeletionStatusPage() {
  const [params] = useSearchParams();
  const code = params.get("code") || "";
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!code) return setErr("Der mangler en bekræftelseskode i linket.");
    api.get("/facebook/data-deletion/status", { params: { code } })
      .then((x) => setR(x.data))
      .catch((e) => setErr(apiError(e.response?.data?.detail) || "Kunne ikke hente status."));
  }, [code]);
  return (
    <SiteShell>
      <div className="legal" data-testid="deletion-status-page">
        <header className="legal-hero">
          <span className="legal-eyebrow">Sletning</span>
          <h1>Status for sletteanmodning</h1>
          <p>Bekræftelseskode: <b data-testid="deletion-code">{code || "–"}</b></p>
        </header>
        <div className="legal-doc">
          <section>
            {err && <p data-testid="deletion-status-error">{err}</p>}
            {r && (
              <div data-testid="deletion-status">
                <h2>{r.status === "completed" ? "Gennemført" : "Under behandling"}</h2>
                <p>{KIND[r.kind]} – modtaget {new Date(r.created_at).toLocaleString("da-DK")}.</p>
                <p>
                  {r.stores ? `Facebook-forbindelsen er slettet for ${r.stores} butik(ker).` : "Vi fandt ingen butik forbundet med denne Facebook-konto."}
                  {r.customers ? ` ${r.customers} kundeprofil(er) er anonymiseret.` : ""}
                </p>
                <p className="muted">Fakturaer gemmes efter bogføringsloven. Spørgsmål: <a href="mailto:info@jatakpro.dk">info@jatakpro.dk</a></p>
              </div>
            )}
            <p><Link to="/sletning-af-data">Sådan sletter du data</Link></p>
          </section>
        </div>
      </div>
    </SiteShell>
  );
}
